export default __webpack_public_path__ + "static/pledge_biodiversity-b9ec1eab9bb9c72725b877cf6353df3e.webp";